// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[6].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[6].use[2]!../breakpoints.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_main__LrA8W {
    max-width: 100vw;
}

.styles_main__LrA8W:not(.styles_contactPage__1HdHf) {
    transition: padding 0.4s;
    padding-left: var(--sidebar-collapsed-width);
}

.styles_main__LrA8W:before {
    content: '';
    display: block;
    position: absolute;
    background: rgba(var(--light-grey-rgb), 0.4);
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: 25;
    transition:
        transform 0.4s,
        opacity 0.4s;
    transform: scaleX(0);
    transform-origin: left top;
    opacity: 0;
}

@media ${___CSS_LOADER_ICSS_IMPORT_0___.locals["screen-md-max"]} and (min-width: 1500px) {
    .styles_menuOpen__mtlEi.styles_shift__LESI0 {
        padding-left: var(--sidebar-expanded-width);
    }
}

@media (max-width: 2380px) {
    .styles_menuOpen__mtlEi.styles_overlay__OECM8:before
    /*.menuOpen.overlayMid:before */ {
        opacity: 1;
        transform: scaleX(1);
    }
}

@media (max-width: 1500px) {
    .styles_menuOpen__mtlEi.styles_overlayMid__Mr4No:before {
        opacity: 1;
        transform: scaleX(1);
    }

    .styles_menuOpen__mtlEi.styles_shift__LESI0:before {
        padding-left: var(--sidebar-collapsed-width);

        opacity: 1;
        transform: scaleX(1);
    }
}
`, "",{"version":3,"sources":["webpack://./src/layouts/styles.module.css"],"names":[],"mappings":"AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,wBAAwB;IACxB,4CAA4C;AAChD;;AAEA;IACI,WAAW;IACX,cAAc;IACd,kBAAkB;IAClB,4CAA4C;IAC5C,WAAW;IACX,YAAY;IACZ,MAAM;IACN,OAAO;IACP,WAAW;IACX;;oBAEgB;IAChB,oBAAoB;IACpB,0BAA0B;IAC1B,UAAU;AACd;;AAEA;IACI;QACI,2CAA2C;IAC/C;AACJ;;AAEA;IACI;;QAEI,UAAU;QACV,oBAAoB;IACxB;AACJ;;AAEA;IACI;QACI,UAAU;QACV,oBAAoB;IACxB;;IAEA;QACI,4CAA4C;;QAE5C,UAAU;QACV,oBAAoB;IACxB;AACJ","sourcesContent":["@value screen-md-max from '../breakpoints.css';\n\n.main {\n    max-width: 100vw;\n}\n\n.main:not(.contactPage) {\n    transition: padding 0.4s;\n    padding-left: var(--sidebar-collapsed-width);\n}\n\n.main:before {\n    content: '';\n    display: block;\n    position: absolute;\n    background: rgba(var(--light-grey-rgb), 0.4);\n    width: 100%;\n    height: 100%;\n    top: 0;\n    left: 0;\n    z-index: 25;\n    transition:\n        transform 0.4s,\n        opacity 0.4s;\n    transform: scaleX(0);\n    transform-origin: left top;\n    opacity: 0;\n}\n\n@media screen-md-max and (min-width: 1500px) {\n    .menuOpen.shift {\n        padding-left: var(--sidebar-expanded-width);\n    }\n}\n\n@media (max-width: 2380px) {\n    .menuOpen.overlay:before\n    /*.menuOpen.overlayMid:before */ {\n        opacity: 1;\n        transform: scaleX(1);\n    }\n}\n\n@media (max-width: 1500px) {\n    .menuOpen.overlayMid:before {\n        opacity: 1;\n        transform: scaleX(1);\n    }\n\n    .menuOpen.shift:before {\n        padding-left: var(--sidebar-collapsed-width);\n\n        opacity: 1;\n        transform: scaleX(1);\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"screen-md-max": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["screen-md-max"]}`,
	"main": `styles_main__LrA8W`,
	"contactPage": `styles_contactPage__1HdHf`,
	"menuOpen": `styles_menuOpen__mtlEi`,
	"shift": `styles_shift__LESI0`,
	"overlay": `styles_overlay__OECM8`,
	"overlayMid": `styles_overlayMid__Mr4No`
};
export default ___CSS_LOADER_EXPORT___;
